'use strict';

(()=>{
	'use strict';

	const carouselPlans = $('.owl-carousel');

	carouselPlans.owlCarousel({
		center: true,
		responsiveClass:true,
		stagePadding: 25,
		margin: 10,
		responsive: {
			0: {
				items: 1,
				nav: false
			}
		}
	});

	$('.home-testimonials .icon-arrow-left').click((e)=> {
		e.preventDefault();
		carouselPlans.trigger('prev.owl.carousel');
	})

	$('.home-testimonials .icon-arrow-right').click((e)=> {
		e.preventDefault();
		carouselPlans.trigger('next.owl.carousel');
	})

})();
